const table = [
  {
    prop: 'name',
    label: 'Nombre',
    minWidth: 200
  },
]
export default table
